import React from 'react';
import { Link } from '@reach/router';
import Button from '@material-ui/core/Button';
import LOGIN from './login-mutation';
import classes from './login.module.scss';
import SocialLogin from './social-login/social-login';
import Form, { IState } from '../../form/form';
import {
  emailValidator,
  minLength,
  required
} from '../../../validators/form-validators';

const Login = props => {
  const redirectLink =
    props &&
    props.location &&
    props.location.state &&
    props.location.state.redirectAfterLogin;
  const state: IState = {
    email: {
      label: 'Електронна адреса',
      config: {
        type: 'email',
        placeholder: 'Введіть свою електронну адресу'
      },
      value: '',
      validators: [required, emailValidator],
      errorMessage: ''
    },
    password: {
      label: 'Пароль',
      config: {
        type: 'password',
        name: 'password',
        placeholder: `Введіть свій пароль`
      },
      value: '',
      validators: [required, minLength(6)],
      errorMessage: ''
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div>
          <span className={classes.enterPersonalRoomText}>
            Увійти в персональний кабінет
          </span>
          <span className={classes.enterDetailsText}>
            Введіть нижче свої деталі
          </span>
        </div>
        <Link to="/signup" style={{ textDecoration: 'none' }}>
          <Button
            data-e2e-id={'register-button'}
            variant="outlined"
            style={{ textTransform: 'capitalize' }}
          >
            Зареєструватися
          </Button>
        </Link>
      </div>
      <Form
        state={state}
        mutation={LOGIN}
        submitOptions={{
          keys: ['email', 'password'],
          label: 'Увійти',
          id: 'login',
          redirectTo: redirectLink || '/'
        }}
      />
      <Link to="/forgot-password" className={classes.forgotPassword}>
        Забули пароль?
      </Link>
      <div className={classes.or}>
        <span>або</span>
      </div>
      <SocialLogin redirectTo={redirectLink || '/'} />
    </div>
  );
};

export default Login;
